import { SVGProps, Ref, forwardRef } from 'react';

export const TinkoffSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 1H1v11.064a7.94 7.94 0 0 0 3.97 6.877L12 23l7.03-4.06A7.94 7.94 0 0 0 23 12.065zM7.036 6.827v-.003l-.003.003zm0 0v3.437c.472-.533 1.326-.892 2.304-.892h1.063v4.002c0 1.065-.29 1.995-.72 2.509h4.625c-.427-.514-.716-1.444-.716-2.506V9.375h1.062c.979 0 1.836.36 2.304.892v-3.44z"
            fill="currentColor"
        />
    </svg>
));
TinkoffSolidSize24Glyph.displayName = 'TinkoffSolidSize24Glyph';
